export const AdvancedSettingsConstants = {
    manageAdvancedSettings: 'Manage Advanced Settings',
    enableNegNemInCommodities: 'Enable NEG/NEM in Commodities',
};
